module.exports = __webpack_public_path__ + "static/media/Lirra.51774468.png";